import axios from 'axios';
import Fuse from 'fuse.js';
import { eventsSearchKeys, fuseSearch } from '@upshow/live-events';
import { getHeaders } from './headers'
import { BASE_URL } from '../../constants/general';

const getLogo = (logos, variant) => logos?.find(l => l.variant === variant)?.asset;

const getMatchedEvents = (type, term, events) => {
    if (!events || events?.length === 0) return [];
    switch (type) {
        case "league":
            return events.filter((event) => event.leagues?.some((league) => league.alias.toLowerCase().includes(term.toLowerCase())));
        case "conference":
            return events.filter((event) => event.conferences?.some((conference) => conference.alias.toLowerCase().includes(term.toLowerCase())));
        case "subscription_type":
            return events.filter((event) => event.subscriptionType?.backwards_compatible_name.toLowerCase().includes(term.toLowerCase()));
        default:
            return fuseSearch(Fuse, events, eventsSearchKeys, term);
    }
};

const processShortcuts = (shortcutsList, events) => {
    return shortcutsList
        .reduce((filteredShortcuts, shortcut) => {
            const matchedEvents = getMatchedEvents(shortcut.searchType, shortcut.searchTerm, events);
            if (matchedEvents.length === 0) return filteredShortcuts;
            const hasLiveEvent = matchedEvents.some((event) => Boolean(event.live));
            filteredShortcuts.push({ 
                ...shortcut, 
                hasLiveEvent,
                logo: getLogo(shortcut.logos, 'default'),
                defaultLogo: getLogo(shortcut.logos, 'fallback')
            });
            return filteredShortcuts;
        }, [])
        .sort((a, b) => a.order - b.order);
};

export const getMenuData = async (events) => {
    const { data } = await axios.get(`${BASE_URL}/v6/menu_data`, {
        headers: getHeaders(),
    });

    const sportsWithEvents = data.sports.filter((sport) => events.some((ev) => Array.isArray(ev.sports) && ev.sports.some((s) => String(s.id) === String(sport.id))));
    const shortcuts = data.shortcuts ?? [];
    const partnerShortcuts = data.partnerShortcuts ?? [];

    const orderedShortcutsWithContent = processShortcuts(shortcuts, events);
    const orderedPartnerShortcutsWithContent = processShortcuts(partnerShortcuts, events);

    return {
        sports: sportsWithEvents,
        shortcuts: orderedShortcutsWithContent,
        partnerShortcuts: orderedPartnerShortcutsWithContent
    };
};
